
import ExpansionPanels from '@/components/molecules/accordion/expansion-panels';
import { generateFaqRichData } from '@/utils/faq-rich-data';

export default {
  name: 'GeneralFaqSection',

  components: {
    ExpansionPanels,
  },

  jsonld() {
    if (this.faqItems.length === 0) {
      return {};
    }
    return generateFaqRichData(this.faqItems);
  },

  props: {
    faqItems: {
      type: Array,
      default: () => [],
    },
  },
};
